export default {
    replaceLetters(word) {
        let newWord = word;
        // A
        newWord = newWord.replace('Ä', 'Ae');
        newWord = newWord.replace('Á', 'A');
        newWord = newWord.replace('À', 'A');
        newWord = newWord.replace('Â', 'A');
        newWord = newWord.replace('Å', 'A');
        newWord = newWord.replace('Ą', 'A');
        // a
        newWord = newWord.replace('ä', 'ae');
        newWord = newWord.replace('á', 'a');
        newWord = newWord.replace('à', 'a');
        newWord = newWord.replace('â', 'a');
        newWord = newWord.replace('å', 'a');
        newWord = newWord.replace('ą', 'a');
        // E
        newWord = newWord.replace('É', 'E');
        newWord = newWord.replace('È', 'E');
        newWord = newWord.replace('Ê', 'E');
        newWord = newWord.replace('Ë', 'E');
        newWord = newWord.replace('Ę', 'E');
        newWord = newWord.replace('Ě', 'E');
        // e
        newWord = newWord.replace('é', 'e');
        newWord = newWord.replace('è', 'e');
        newWord = newWord.replace('ê', 'e');
        newWord = newWord.replace('ë', 'e');
        newWord = newWord.replace('ę', 'e');
        newWord = newWord.replace('ě', 'e');
        // I
        newWord = newWord.replace('Í', 'I');
        newWord = newWord.replace('Ì', 'I');
        newWord = newWord.replace('Î', 'I');
        newWord = newWord.replace('Ï', 'I');
        newWord = newWord.replace('İ', 'I');
        // i
        newWord = newWord.replace('í', 'i');
        newWord = newWord.replace('ì', 'i');
        newWord = newWord.replace('î', 'i');
        newWord = newWord.replace('ï', 'i');
        newWord = newWord.replace('ı', 'i');
        // O
        newWord = newWord.replace('Ö', 'Oe');
        newWord = newWord.replace('Ó', 'O');
        newWord = newWord.replace('Ò', 'O');
        newWord = newWord.replace('Ô', 'O');
        newWord = newWord.replace('Ø', 'O');
        // o
        newWord = newWord.replace('ö', 'oe');
        newWord = newWord.replace('ó', 'o');
        newWord = newWord.replace('ò', 'o');
        newWord = newWord.replace('ô', 'o');
        newWord = newWord.replace('ø', 'o');
        // U
        newWord = newWord.replace('Ü', 'Ue');
        newWord = newWord.replace('Ú', 'U');
        newWord = newWord.replace('Ù', 'U');
        newWord = newWord.replace('Û', 'U');
        newWord = newWord.replace('Ů', 'U');
        // u
        newWord = newWord.replace('ü', 'ue');
        newWord = newWord.replace('ú', 'u');
        newWord = newWord.replace('ù', 'u');
        newWord = newWord.replace('û', 'u');
        newWord = newWord.replace('ů', 'u');
        // S
        newWord = newWord.replace('Ś', 'S');
        newWord = newWord.replace('Š', 'S');
        newWord = newWord.replace('Š', 'S');
        newWord = newWord.replace('Ş', 'S');
        // s
        newWord = newWord.replace('ß', 'ss');
        newWord = newWord.replace('ś', 's');
        newWord = newWord.replace('š', 's');
        newWord = newWord.replace('š', 's');
        newWord = newWord.replace('ş', 's');
        // sonstige
        newWord = newWord.replace('Ç', 'C');
        newWord = newWord.replace('Ç', 'C');
        newWord = newWord.replace('ç', 'c');
        newWord = newWord.replace('ç', 'c');
        newWord = newWord.replace('Ć', 'C');
        newWord = newWord.replace('Č', 'C');
        newWord = newWord.replace('ć', 'c');
        newWord = newWord.replace('č', 'c');
        newWord = newWord.replace('Ď', 'D');
        newWord = newWord.replace('ď', 'd');
        newWord = newWord.replace('Ğ', 'G');
        newWord = newWord.replace('ğ', 'g');
        newWord = newWord.replace('Ł', 'L');
        newWord = newWord.replace('ł', 'l');
        newWord = newWord.replace('Ň', 'N');
        newWord = newWord.replace('ň', 'n');
        newWord = newWord.replace('Ń', 'N');
        newWord = newWord.replace('ń', 'n');
        newWord = newWord.replace('Ñ', 'N');
        newWord = newWord.replace('ñ', 'n');
        newWord = newWord.replace('Ř', 'R');
        newWord = newWord.replace('ř', 'r');
        newWord = newWord.replace('Ť', 'T');
        newWord = newWord.replace('ť', 't');
        newWord = newWord.replace('Ý', 'Y');
        newWord = newWord.replace('ý', 'y');
        newWord = newWord.replace('ÿ', 'y');
        newWord = newWord.replace('Ÿ', 'Y');
        newWord = newWord.replace('Ž', 'Z');
        newWord = newWord.replace('ž', 'z');
        newWord = newWord.replace('Ź', 'Z');
        newWord = newWord.replace('ź', 'z');
        newWord = newWord.replace('Ż', 'Z');
        newWord = newWord.replace('ż', 'z');
        newWord = newWord.replace('Ž', 'Z');
        newWord = newWord.replace('ž', 'z');
        return newWord;
    }
}